import { Trans } from '@lingui/react/macro'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from 'designSystem/components/Dialog'
import { RevisionCompareContent } from 'features/knowledgeDocumentViewer/components/revisionCompare/RevisionCompareContent'
import type { CanonicalRevisionModel } from 'features/knowledgeDocumentViewer/components/revisionCompare/revisionMemberCanonical'
import type { FimRevisionDiffDetailEntry } from 'features/knowledgeDocumentViewer/hooks/useRevisionDiffDetails'

type RevisionCompareViewProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  details: readonly FimRevisionDiffDetailEntry[]
  canonicalRevisionModel: CanonicalRevisionModel
  currentBqDocumentId: string
  currentPageNum: number
}

export function RevisionCompareView({
  open,
  onOpenChange,
  details,
  canonicalRevisionModel,
  currentBqDocumentId,
  currentPageNum,
}: RevisionCompareViewProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent layout='fill' aria-describedby={undefined}>
        <DialogTitle>
          <Trans>What changed</Trans>
        </DialogTitle>
        <RevisionCompareContent
          open={open}
          details={details}
          canonicalRevisionModel={canonicalRevisionModel}
          currentBqDocumentId={currentBqDocumentId}
          currentPageNum={currentPageNum}
        />
      </DialogContent>
    </Dialog>
  )
}
